import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const problems = ['Tu hijo se aburre cuando intenta escribir.', 'Se distrae fácilmente.', 'Prefiere las pantallas antes que aprender.', 'No sabés qué actividades utilizar.', 'Terminan frustrados los dos.', 'Sentís que no avanzan.'];
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-204">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-206">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4" data-id="element-207">
            ¿Te identificás con alguna de estas situaciones?
          </h2>
          <div className="w-24 h-1.5 bg-pastel-coral mx-auto rounded-full" data-id="element-208"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-209">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-slate-50 border border-slate-100 rounded-2xl p-6 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-210">
              <XCircle className="w-8 h-8 text-pastel-coral shrink-0" data-id="element-211" />
              <p className="text-lg font-medium text-slate-700 leading-snug" data-id="element-212">
                {problem}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-16 text-center bg-pastel-blueLight/50 p-8 rounded-3xl" data-id="element-213">
          <p className="text-2xl font-bold text-slate-800" data-id="element-214">
            No estás sola.{' '}
            <span className="text-pastel-lilac" data-id="element-215">
              Miles de mamás viven exactamente lo mismo.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}